import { render, staticRenderFns } from "./goodFamily.vue?vue&type=template&id=48f7b986&"
import script from "./goodFamily.vue?vue&type=script&lang=js&"
export * from "./goodFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports